import { TrackedEvents, trackEvent } from 'analytics';
import { useTranslation } from 'i18n';
import { useNavigate } from 'react-router-dom';
import { DataCard, ExpandableIconButton } from 'ui';
import { ImageOutlined, OtherHousesOutlined } from 'ui/icons';
export const SiteDataCard = ({
  isLoading,
  storageConditions,
  inputMaterialNotes,
  machinesUsedNotes,
  storedOn,
  productionVolume,
  siteNotes,
  hasMedia,
}: {
  isLoading?: boolean;
  storageConditions?: string | null;
  inputMaterialNotes?: string | null;
  machinesUsedNotes?: string | null;
  storedOn?: string | null;
  productionVolume?: number | null;
  siteNotes?: string | null;
  hasMedia: boolean;
}) => {
  const { t } = useTranslation('features');
  const navigate = useNavigate();

  const handleClickMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_CATEGORY_IMAGES, {
      category: 'Site',
    });
    navigate('media?tab=site');
  };

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          action: hasMedia ? (
            <ExpandableIconButton
              icon={<ImageOutlined />}
              label={t('dataCards.site.actions.showMedia')}
              onClick={handleClickMedia}
            />
          ) : undefined,
          avatar: <OtherHousesOutlined />,
          title: t('dataCards.site.title'),
        },
      }}
    >
      {storageConditions ? (
        <DataCard.Item title={t('dataCards.site.fields.storageAndCover')}>{storageConditions}</DataCard.Item>
      ) : null}
      {inputMaterialNotes ? (
        <DataCard.Item title={t('dataCards.site.fields.materialOrigin')}>{inputMaterialNotes}</DataCard.Item>
      ) : null}

      {machinesUsedNotes ? (
        <DataCard.Item title={t('dataCards.site.fields.machinesUsed')}>{machinesUsedNotes}</DataCard.Item>
      ) : null}

      {storedOn ? <DataCard.Item title={t('dataCards.site.fields.siteGround')}>{storedOn}</DataCard.Item> : null}

      {productionVolume ? (
        <DataCard.Item title={t('dataCards.site.fields.monthlyVolume')}>
          {t('dataCards.site.monthlyVolumeValue', { values: { productionVolume } })}
        </DataCard.Item>
      ) : null}

      {siteNotes ? (
        <DataCard.Item title={t('dataCards.site.fields.siteNotes')} colSpan={12}>
          {siteNotes}
        </DataCard.Item>
      ) : null}
    </DataCard>
  );
};
